"use client";

import React, { useState } from "react";
import { Typography} from "@material-tailwind/react";
import BottleConditionsCard from "../components/bottle-conditions-card";
import { MotionDiv, MotionSection, MotionForm, Variants } from "@/utils/clientMotion";

// 1. container variants: สั่งให้ลูกเด้งทีละตัว
const containerVariants: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2 } },
};

// 2. item variants: เด้งลงมาจากด้านบน + fade-in
const itemVariants: Variants = {
  hidden: { y: -50, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 120, damping: 12 },
  },
};

const UPCYCLEDPRODUCTS = [
  {
    client: "เทน้ำออกจากขวดจนหมด",
    img: "/image/do1bottlecond.webp",
    alt: "เทน้ำออกจากขวดจนหมด",
    color: "green",
  },
  {
    client: "ต้องเป็นขวด PET แบบใสเท่านั้น \nหรือ สังเกตสัญลักษณ์รีไซเคิล",
    img: "/image/do2bottlecond.webp",
    alt: "ต้องเป็นขวด PET แบบใสเท่านั้น หรือ สังเกตสัญลักษณ์รีไซเคิล",
    color: "green",
  },
  {
    client: "หลีกเลี่ยงการนำวัสดุรูปแบบอื่นมาหยอด เช่น\u00A0กระป๋อง\u00A0ซองพลาสติก\u00A0เป็นต้น",
    img: "/image/dontbottlecond.webp",
    alt: "ไม่ใช่ขวด PET แบบใส",
    color: "red",
  },
];

export function RebottBottleConditions() {

  const [selected, setSelected] = useState<number | null>(null);

  return (
    <MotionSection
      className="px-10 py-20 bg-[#eff6ff]"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.3 }}
      variants={containerVariants}
    >
      <div className="container mx-auto"> 
      <MotionDiv 
            variants={itemVariants}
            className="mb-10 flex w-full flex-col !items-center"
          >
          <Typography {...({} as any)} variant="h3" className="mb-1 text-center text-gray-800">
          เงื่อนไข<br className="block md:hidden" />การหยอดขวดพลาสติก
          <br className="block md:hidden" />ลงในตู้ <span className="text-[#2998E2]">Rebott</span>
          </Typography>
        </MotionDiv>
        <div className="container mx-auto grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-12 lg:px-12">
        {UPCYCLEDPRODUCTS.map((item, idx) => {
          // คำนวณสีพื้นหลังตอนถูกเลือก
          const isSel = selected === idx;
          const bgColor = isSel
            ? item.color === "green"
              ? "bg-green-50"
              : "bg-red-50"
            : "bg-white";
          // คำนวณสีพื้นหลังตอน hover
          const hoverBg = item.color === "green"
            ? "hover:bg-green-100/50"
            : "hover:bg-red-100/50";

          return (
            <MotionDiv
              key={idx}
              variants={itemVariants}
              className={`
                p-4 rounded-[20px] cursor-pointer transition-colors
                ${bgColor} ${hoverBg}
              `}
              // ดีดขยายเล็กน้อยตอน hover/tap
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 1.05 }}
              onClick={() =>
                setSelected(isSel ? null : idx)
              }
            >
              <BottleConditionsCard
                img={item.img}
                client={item.client}
                alt={item.alt}
              />
            </MotionDiv>
          );
        })}
        </div>
      </div>
    </MotionSection>
  );
}
export default RebottBottleConditions;
